var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRouteItemDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_685_18048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 6.9 10.9 6 12 6H27.35L36.66 15.28V36C36.66 37.1 35.76 38 34.66 38H12C10.9 38 10 37.1 10 36V8Z",
    fill: "#5AD6A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.34 6V14.26C27.34 14.81 27.79 15.26 28.34 15.26H36.66",
    fill: "#99EDC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 18.38H16.41V20.37H30.27V18.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 29.84H16.41V31.83H30.27V29.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 26.08H16.41V28.07H30.27V26.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 22.37H16.41V24.36H30.27V22.37Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 2H38V14H40V2Z",
    fill: "#5AD6A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7H33V9H45V7Z",
    fill: "#5AD6A2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_685_18048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.67,
    height: 32,
    fill: "white",
    transform: "translate(10 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRouteItemDownload);
export default __webpack_public_path__ + "static/media/ic_route_item_download.eaa19bdfa91f713797501ebd227dbff1.svg";
export { ForwardRef as ReactComponent };